module.exports = __webpack_public_path__ + "media/seo/ca-fr-6549bbf1.jpg";